import React, { useEffect, useState } from 'react'
import Navbars from '../../../Components/Navbar'
import LoadingSpinner from '../../../Components/LoadingSpinner'
import * as XLSX from 'xlsx'
import { Form, Toast, Button } from 'react-bootstrap'
import uuid from 'react-uuid'
import './uploadStyle.css'
import firebaseConfig from '../../../Utilities/Firebase'
import { getDatabase, ref, update } from 'firebase/database'
import { initializeApp } from 'firebase/app'
import { useNavigate } from 'react-router'
import { getAuth, onAuthStateChanged } from 'firebase/auth'

function UploadCgpa() {
  const [isLoading, setIsLoading] = useState(false)
  const [items, setItems] = useState([])
  const [show, setShow] = useState(false)
  const [showError, setShowError] = useState(false)
  const [message, setMessage] = useState('')
  const navigate = useNavigate()

  useEffect(() => {
    IsUserLogedIn()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  function IsUserLogedIn() {
    const FirebaseApp = initializeApp(firebaseConfig)
    const auth = getAuth(FirebaseApp)
    onAuthStateChanged(auth, user => {
      if (user === null) {
        navigate('/')
      }
    })
  }

  const readExcel = file => {
    setItems([])
    try {
      const promise = new Promise((resolve, reject) => {
        const fileReader = new FileReader()
        fileReader.readAsArrayBuffer(file)
        fileReader.onload = e => {
          const bufferArray = e.target.result
          const wb = XLSX.read(bufferArray, { type: 'buffer' })
          const wsname = wb.SheetNames[0]
          const ws = wb.Sheets[wsname]
          const data = XLSX.utils.sheet_to_json(ws)
          resolve(data)
        }

        fileReader.onerror = error => {
          reject(error)
        }
      })

      promise.then(d => {
        var temp = []
        for (var i = 0; i < d.length; i++) {
          var sap_id = d[i]["Student's No."]
          var name = d[i]["Student's Name"]
          var program = d[i]['Program']
          var cgpa = d[i]['CGPA']
          var year = d[i]['Year']
          var result = d[i]['Result']
          temp.push({ sap_id, name, program, cgpa, passing_year: year, result })
        }
        if (temp.length > 0) {
          setItems(temp)
        } else {
          setMessage('WRONG FORMAT OF EXCEL')
          setShowError(true)
        }
      })
    } catch (e) {
      setMessage('OOPPS ERROR')
      setShowError(true)
    }
  }

  function upload() {
    console.log('UPLOAD STARTED')
    setIsLoading(true)
    const FirebaseApp = initializeApp(firebaseConfig)
    const db = getDatabase(FirebaseApp)
    uploadToDb(0, db)
  }

  function uploadToDb(index, db) {
    if (index === items.length) {
      setItems([])
      setIsLoading(false)
      setShow(true)
      return
    } else {
      let value = items[index]
      update(ref(db, 'student_data/' + value.sap_id), {
        cgpa: value.cgpa,
        passing_year: value.passing_year,
        final_result: value.result,
      })
        .then(() => {
          uploadToDb(index + 1, db)
          console.log('Data uploaded successfully')
        })
        .catch(error => {
          console.log(error)
          setIsLoading(false)
          setMessage('SOME ERROR OCCURED')
          setShowError(true)
          return
        })
    }
  }

  /*{
          sap_id: sap_id,
          first_name: first_name,
          last_name: last_name,
          father_name: father_name,
          mother_name: mother_name,
          dob: dob,
          course: course,
          year: year,
          email: email,
          phone_number1: phone_number1,
          phone_number2: phone_number2,
          address: address,
          district: district,
          postalCode: postalCode,
          station: station,
          city: city,
          state: state,
          country: country,
          sub_caste: sub_caste,
          religion: religion,
          registration_date: registration_date,

      }*/

  function resetForm() {
    setItems([])
    document.getElementById('form').reset()
  }

  return isLoading ? (
    <LoadingSpinner />
  ) : (
    <div>
      <div style={{ position: 'fixed', bottom: '2%', right: '3%' }}>
        <Toast onClose={() => setShow(false)} show={show} delay={3000} autohide bg="success">
          <Toast.Body style={{ fontWeight: 'bold', color: 'white' }}>Successfully uploaded!</Toast.Body>
        </Toast>
      </div>

      <div style={{ position: 'fixed', bottom: '2%', right: '3%' }}>
        <Toast onClose={() => setShowError(false)} show={showError} delay={3000} autohide bg="danger">
          <Toast.Body style={{ fontWeight: 'bold', color: 'white' }}>{message}</Toast.Body>
        </Toast>
      </div>

      <Navbars type={'1'} />
      <br />
      <br />
      <br />
      <center>
        <Form id="form" style={{ border: '1px black solid', width: '50%' }}>
          <br />
          <br />
          <Form.Control
            type="file"
            onInput={e => {
              const file = e.target.files[0]
              readExcel(file)
            }}
            accept=".xlsx"
            placeholder="Select file"
            style={{ marginTop: '2%', width: '50%' }}
          />
          <br />
          <br />
          <Button
            onClick={() => {
              upload()
            }}
          >
            Upload
          </Button>
          <Button
            onClick={() => {
              resetForm()
            }}
            style={{ marginLeft: '5%' }}
          >
            Reset
          </Button>
          <br />
          <br />
          <br />
        </Form>
      </center>

      {items.length > 0 ? (
        <div style={{ marginLeft: '1%' }}>
          <br />
          <br />
          <h4>Preview</h4>
          <br />
          <div>
            <table>
              <tbody>
                <tr>
                  <th>Student's No.</th>
                  <th>Student's Name</th>
                  <th>Program</th>
                  <th>CGPA</th>
                  <th>Year</th>
                  <th>Result</th>
                </tr>

                {items.map(value => {
                  return (
                    <tr key={uuid()}>
                      <td>{value.sap_id}</td>
                      <td>{value.name}</td>
                      <td>{value.program}</td>
                      <td>{value.cgpa}</td>
                      <td>{value.passing_year}</td>
                      <td>{value.result}</td>
                    </tr>
                  )
                })}
              </tbody>
            </table>
          </div>
          <br />
          <br />
          <div />
        </div>
      ) : null}
    </div>
  )
}
export default UploadCgpa
